import { render, staticRenderFns } from "./image_manage.vue?vue&type=template&id=3160ef6c&scoped=true"
import script from "./image_manage.vue?vue&type=script&lang=js"
export * from "./image_manage.vue?vue&type=script&lang=js"
import style0 from "./image_manage.vue?vue&type=style&index=0&id=3160ef6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3160ef6c",
  null
  
)

export default component.exports